import React from 'react';

import { Box } from '@chakra-ui/react';
import { GoalFrequency, GoalsCollaborators, Milestone, Peer, Settings, SplitDetails } from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { IconSteps, StepCard } from '../commonComponents';

const GuideSection = () => (
  <StepCard title="On Mesh you'll get notified of the following">
    <Box>
      <IconSteps
        steps={[
          {
            iconSvg: Peer,
            stepComp: <TextBodyMedium>View who all are collaborating on Goals and Initiatives</TextBodyMedium>,
          },
          {
            iconSvg: Settings,
            stepComp: <TextBodyMedium>Configure custom tabs on Teams to view items from Mesh</TextBodyMedium>,
          },
          {
            iconSvg: GoalFrequency,
            stepComp: <TextBodyMedium>View your goals from Mesh in the list view</TextBodyMedium>,
          },
          {
            iconSvg: SplitDetails,
            stepComp: (
              <TextBodyMedium>Expand goals to the detailed panel and make edits directly in Teams</TextBodyMedium>
            ),
          },
          {
            iconSvg: GoalsCollaborators,
            stepComp: <TextBodyMedium>View which team members are collaborating on projects and tasks</TextBodyMedium>,
          },
          {
            iconSvg: Milestone,
            stepComp: (
              <TextBodyMedium>
                Track progress on all your goals and initiatives from your custom Teams tabs
              </TextBodyMedium>
            ),
          },
        ]}
      />
    </Box>
  </StepCard>
);

export { GuideSection };
